<template>
  <div>
    <reenrollment-edit-modal
      :reenrollment="reenrollment"
      @close="closeReenrollmentEditModal"
      v-if="showReenrollmentEditModal"
    />

    <confirm-modal
      v-if="showReenrollingModal"
      @close="closeReenrollingModal"
      @confirm="reenroll()"
      message="Essa ação gerará o contrato do aluno com suas respectivas
               mensalidades de acordo com os dados configurados na rematrícula.
               Deseja continuar?"
    />

    <confirm-modal
      v-if="showCancelContractModal"
      @close="closeCancelContractModal"
      @confirm="cancelReenrollment()"
      message="Essa ação irá cancelar o contrato prévio de rematrícula criado.
               Tem certeza que deseja seguir com a solicitação?"
    />


    <div class="student-view__header-title">
      <h4><strong>Rematrícula</strong></h4>

      <div class="dropdown" v-if="canEditReenrollment">
        <button
          class="btn btn-primary dropdown-toggle"
          type="button"
          :id="`dropdown-reenrollment-options-${reenrollment.id}`"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          Ações
          <span class="caret"></span>
        </button>
        <ul
          class="dropdown-menu dropdown-menu-right"
          :aria-labelledby="`dropdown-reenrollment-options-${reenrollment.id}`"
        >
          <li>
            <a @click="openReenrollingModal('generateContract')"> Gerar contrato </a>
          </li>
          <li>
            <a @click="openReenrollmentEditModal()"> Editar </a>
          </li>
          <li>
            <a @click="openReenrollingModal('cancelReenrollment')"> Cancelar Rematrícula </a>
          </li>
        </ul>
      </div>
    </div>

    <table class="table table-bordered">
      <thead>
        <tr>
          <th>ID</th>
          <th>Status</th>
          <th>Tipo de rematrícula</th>
          <th>Valor a ser cobrado</th>
          <th>Parcelas</th>
          <th>Semestre</th>
          <th>Data de início</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ reenrollment.id }}</td>
          <td>{{ reenrollment.translated_status }}</td>
          <td>{{ reenrollment.translated_fee_type }}</td>
          <td>{{ reenrollment.due_amount | formatCurrency }}</td>
          <td>{{ reenrollment.installments }}</td>
          <td>{{ reenrollment.period }}</td>
          <td>{{ reenrollment.start_date | formatDate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ConfirmModal from 'components/ConfirmModal';
import ReenrollmentService from 'services/ReenrollmentService';
import ReenrollmentEditModal from './modals/ReenrollmentEditModal.vue';

export default {
  components: {
    ConfirmModal,
    ReenrollmentEditModal,
  },
  props: {
    reenrollment: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      waitingBoleto: false,
      downloadingBoleto: false,
      showReenrollmentEditModal: false,
      showReenrollingModal: false,
      showCancelContractModal: false,
    };
  },
  computed: {
    canEditReenrollment() {
      return (
        !['interrupted', 'rejected', 'reenrolled'].includes(this.reenrollment.status)
      );
    },
    paymentPromise() {
      if (!this.reenrollment.payment_promise) {
        return {};
      }

      return this.reenrollment.payment_promise;
    },
    isWaitingContractDischarge() {
      return this.reenrollment.status === 'waiting_contract_discharge';
    },
    forceReenroll() {
      return this.isWaitingContractDischarge;
    },
  },
  methods: {
    openReenrollmentEditModal() {
      this.showReenrollmentEditModal = true;
    },
    closeReenrollmentEditModal() {
      this.showReenrollmentEditModal = false;
    },
    openReenrollingModal(action) {
      if (action === 'generateContract') {
        this.showReenrollingModal = true;
      } else if (action === 'cancelReenrollment') {
        this.showCancelContractModal = true;
      }
    },
    closeReenrollingModal() {
      this.showReenrollingModal = false;
    },
    closeCancelContractModal() {
      this.showCancelContractModal = false;
    },
    reenroll() {
      this.$loader.show();

      ReenrollmentService.reenroll(this.reenrollment.id, this.forceReenroll)
        .then(() => {
          this.$alert.notifySuccess('Contrato gerado com sucesso');
        })
        .catch(({ response: { data } }) => {
          this.$alert.notifyAlert(data.message);
        })
        .finally(() => {
          this.closeReenrollingModal();
          this.$loader.hide();
        });
    },
    cancelReenrollment() {
      this.$loader.show();

      ReenrollmentService.cancelReenrollment(this.reenrollment.id)
        .then(() => {
          this.$alert.notifySuccess('Solicitação de rematrícula cancelada com sucesso');
        })
        .catch(({ response: { data } }) => {
          this.$alert.notifyAlert(data.message);
        })
        .finally(() => {
          this.closeCancelContractModal();
          this.$loader.hide();
        });
    },
  },
  mounted() {
    if (this.paymentPromise.id && !this.paymentPromise.url) {
      this.waitingBoleto = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.spaced-buttons:not(:last-child) {
  margin-right: 4px;
}
</style>
